class ReleaseConfirmation {
  constructor(
    id,
    equipmentID,
    truckDriverID,
    codeID,
    allowed,
    passwordGenerated,
    rejected,
    equipmentName,
    truckDriverName,
    codeName,
    createdDate
  ) {
    this.id = id
    this.equipmentID = equipmentID
    this.truckDriverID = truckDriverID
    this.codeID = codeID
    this.allowed = allowed
    this.passwordGenerated = passwordGenerated
    this.rejected = rejected
    this.equipmentName = equipmentName
    this.truckDriverName = truckDriverName
    this.codeName = codeName
    this.createdDate = createdDate
  }

}

export const releaseConfirmationDefault = () => {
  const releaseConfirmation = {
    id: 0,
    truckDriverID: 0,
    equipmentID: 0,
    codeID: 0,
    allowed: null,
    passwordGenerated: null,
    rejected: null,
    equipmentName: null,
    truckDriverName: null,
    codeName: null,
    createdDate: 0
  }
  return releaseConfirmation
}

export default ReleaseConfirmation